// extracted by mini-css-extract-plugin
export default {"caixa":"App_caixa__Nm1vl","envelope":"App_envelope__-p8UJ"};